import axios from "axios";
export const loadMasterAdmin = async (cb) => {
  const response = await axios.get("/api/master-admin");

  cb(response.data || null);
};

export const loadAdmins = async () => {
  const response = await axios.get("/api/admins");

  return response.data || [];
};
